import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '../../Spinner';
import { BackdropStyled } from './DialogLoaderBackdrop.styled';
const DialogLoaderBackdrop = (props) => {
    return (_jsx(BackdropStyled, { ...props, children: _jsx(Spinner, { fullHeight: true }) }));
};
export { DialogLoaderBackdrop };
